import '@emotion/react';
import '@mui/material/styles';
import { palette, theme as sharedTheme } from '@phocassoftware/shared-components';
export const resolveDashboardThemeMode = (mode) => (mode === 'dark' ? 'dark' : 'light');
export const createDefaultDashboardPalette = (mode) => mode === 'light'
    ? {
        border: palette.grey.G4,
        divider: palette.grey.G7,
        widget: {
            background: palette.white,
            border: palette.grey.G3,
            hover: palette.grey.G1,
            header: palette.grey.G1
        },
        text: {
            primary: palette.black,
            secondary: palette.grey.G10
        },
        icons: {
            default: palette.grey.G10,
            active: palette.cyan[500],
            disabled: palette.grey.G6
        },
        control: {
            background: palette.white,
            disabledBackground: sharedTheme.functionalColours.control.background.disabled,
            actionBackground: palette.grey.G2,
            actionText: 'inherit',
            highlight: palette.yellow[300]
        },
        background: {
            default: palette.grey.G2,
            secondary: palette.white,
            tertiary: palette.grey.G4,
            subtle: palette.grey.G1
        },
        state: {
            view: {
                background: palette.cyan[100],
                border: palette.cyan[200],
                icon: palette.cyan[500],
                text: palette.cyan[500]
            },
            edit: {
                background: palette.yellow[100],
                border: palette.yellow[200],
                icon: palette.yellow[700],
                text: palette.yellow[700]
            }
        }
    }
    : {
        border: '#292929',
        divider: palette.grey.G8,
        widget: {
            background: '#171717',
            border: palette.grey.G3,
            hover: palette.grey.G1,
            header: '#292929'
        },
        text: {
            primary: palette.white,
            secondary: palette.grey.G1
        },
        icons: {
            default: palette.white,
            active: palette.cyan[500],
            disabled: palette.grey.G6
        },
        control: {
            background: '#383838',
            disabledBackground: '#292929',
            actionBackground: palette.grey.G10,
            actionText: palette.white,
            highlight: palette.yellow[800]
        },
        background: {
            default: '#383838',
            secondary: '#292929',
            tertiary: '#292929',
            subtle: '#383838'
        },
        state: {
            view: {
                background: palette.cyan[900],
                border: palette.cyan[700],
                icon: palette.cyan[500],
                text: palette.cyan[500]
            },
            edit: {
                background: '#403E2A',
                border: palette.yellow[800],
                icon: palette.yellow[700],
                text: palette.yellow[700]
            }
        }
    };
